<!-- eslint-disable vue/html-self-closing -->
<template>
  <button
    :class="[
      'c-button-v3',
      'c-button-v3--primary-clear',
    ]"
    type="button"
    @click.prevent="schoolNotListedDialogRef.show()">
    <music-icon-message-check-mark-square-v3
      navigable="true"
      class="u-fill-widget-red-700"
      size="lg"></music-icon-message-check-mark-square-v3>
    <span> Can't find your school?</span>
  </button>

  <sl-dialog
    ref="schoolNotListedDialogRef"
    :class="[$style['ua-school-not-listed-dialog']]"
  >
    <span slot="label">Is your school not listed?</span>
    <p :class="[$style['ua-school-not-listed-description']]">
      Please complete the form with your school details.
    </p>
    <form
      id="new_school_search_log"
      :class="[$style['ua-school-not-listed-form']]"
      autocomplete="off"
      action="/school_search_log/post_notification"
      accept-charset="UTF-8"
      novalidate
      method="post"
      aria-labelledby="school_search_log_data_error"
      @submit.prevent="onSubmit">
      <l-stack-v3>
        <input
          type="hidden"
          name="authenticity_token"
          :value="authToken"
          autocomplete="off" />
        <ua-form-item ref="schoolNameFormItem">
          <sl-input
            id="school_search_log_name"
            label="School Name"
            v-model="form.name"
            name="school_search_log[name]"
            data-school-name="true"
            size="large"
            required
            @sl-change="onChange">
          </sl-input>
        </ua-form-item>
        <ua-form-item ref="schoolCityFormItem">
          <sl-input
            id="school_search_log_city"
            label="City"
            v-model="form.city"
            name="school_search_log[city]"
            data-school-city="true"
            size="large"
            required
            @sl-change="onChange">
          </sl-input>
        </ua-form-item>
        <ua-form-item ref="schoolStateFormItem">
          <sl-input
            id="school_search_log_state"
            label="State or Province"
            v-model="form.state"
            name="school_search_log[state]"
            data-school-state="true"
            size="large"
            required
            @sl-change="onChange">
          </sl-input>
        </ua-form-item>
        <ua-form-item ref="schoolCountryFormItem">
          <sl-input
            id="school_search_log_country"
            label="Country"
            v-model="form.country"
            name="school_search_log[country]"
            data-school-country="true"
            size="large"
            required
            @sl-change="onChange">
          </sl-input>
        </ua-form-item>
        <input
          id="school_search_log_data"
          autocomplete="off"
          type="hidden"
          name="school_search_log[data]">
      </l-stack-v3>
    </form>
    <p
      id="school_search_log_data_error"
      aria-live="assertive"
      class="u-sr-only"
      :class="testClass('form-error')">
      {{ formErrors }}
    </p>

    <div slot="footer">
      <l-spanner-v3 class="u-mar-top-24">
        <button
          type="button"
          class="c-button-v3  c-button-v3--tertiary"
          @click.prevent="schoolNotListedDialogRef.hide();">
          Return
        </button>
        <button
          type="submit"
          form="new_school_search_log"
          class="c-button-v3  c-button-v3--primary"
          :class="testClass('submit-btn')"
          :disabled="!schoolNotListedDialogAllFieldsFilled">
          Notify Us
        </button>
      </l-spanner-v3>
    </div>
  </sl-dialog>
</template>

<script setup>
  import { ref, onMounted, computed } from 'vue';
  import { default as authToken } from '~/src/shared/lib/auth_token.js'
  import { validations, rulesList } from '~/src/features/registration/validation_rules.js';
  import { testClass } from 'music';

  const schoolNotListedDialogRef = ref(null);

  const form = ref({
    name: '',
    city: '',
    state: '',
    country: ''
  });

  const formErrors = ref('');

  // refs for form items
  const schoolNameFormItem = ref(null);
  const schoolCityFormItem = ref(null);
  const schoolStateFormItem = ref(null);
  const schoolCountryFormItem = ref(null);

  const formItems = [
    schoolNameFormItem,
    schoolCityFormItem,
    schoolStateFormItem,
    schoolCountryFormItem
  ];

  const onChange = (e) => {
    form.value[e.target.name] = e.target.value;
  };

  const addValidations = () => {
    formItems.forEach((item) => {
      item.value.addValidations(rulesList, validations, false);
    });
  };

  const onSubmit = (e) => {
    formErrors.value = '';
    let isValid = true;

    formItems.forEach((item) => {
      if (typeof item.value.validate === 'function') {
        item.value.validate();
      }
      if (!item.value.isValid) {
        isValid = false;
      }
    });
    if (!isValid) {
      formErrors.value = 'Please correct the errors in the form.';
      return;
    }
    e.target.submit();
  };

  
  const schoolNotListedDialogAllFieldsFilled = computed(() =>
    form.value.name.trim() &&
    form.value.city.trim() &&
    form.value.state.trim() &&
    form.value.country.trim()
  );

  onMounted(async () => {
    addValidations();
  });
  
</script>

<style lang="scss" module>
  @use 'music/app/styles/library/base' as * ;

  .ua-school-selection-search__btn-contact-us {
    font-size: var(--music-font-body-2);
    font-weight: var(--music-font-semibold);
    padding-left: 0;
    text-decoration: none;

    music-icon-message-check-mark-square-v3 {
      fill: var(--music-widget-red-700);
    }
  }

  .ua-school-not-listed-dialog {
    // Set dialog width to auto to fit content and left align text
    &::part(panel) {
      text-align: left;
      overflow-y: auto;

      @media screen and (min-width: rpx(600)) and (orientation: landscape) {
        width: rpx(600);
      }
    }

    &::part(body) {
      overflow: visible;
    }

    .ua-school-not-listed-form {
      color: var(--music-true-gray-900);
      font-size: var(--music-font-body-2);
      width: 100%;
    }
  
    .ua-school-not-listed-description {
      margin-bottom: rpx(20);
      padding-left: rpx(4);
    }
  }

</style>
